import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useLanguage } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Included from "@/components/Included";
import MenuSection from "@/components/MenuSection";
import BarMenu from "@/components/BarMenu";
import Journey from "@/components/Journey";
import Booking from "@/components/Booking";
import Practical from "@/components/Practical";
import Footer from "@/components/Footer";
import MusicToggle from "@/components/MusicToggle";

export default function Home() {
  const [params, setParams] = useSearchParams();
  const { t } = useLanguage();

  useEffect(() => {
    if (params.get("cancelled")) {
      toast.error(t.booking.cancelledToast);
      setParams({}, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="bg-night min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <Included />
      <MenuSection />
      <BarMenu />
      <Journey />
      <Booking />
      <Practical />
      <Footer />
      <MusicToggle />
    </main>
  );
}
